import React from "react";
import NewsTicker, { Directions } from "react-advanced-news-ticker";
import tickerIcon from "../img/ticker_icon.svg";

import Gallery from "./Gallery";
export default function Header({ title, description }) {
  return (
    <>
      <img src={tickerIcon} alt="Ticker" className="tickerIcon" />
      <NewsTicker
        rowHeight={26}
        maxRows={1}
        speed={600}
        direction={Directions.UP}
        duration={4000}
        autoStart={true}
        pauseOnHover={false}
        id="myId"
        className="ticker"
      >
        <div>Tips en venn som sliter med panting på farta</div>
        <div>Merk deg dine favoritter</div>
        <div>Stem frem Norges beste bæremåte</div>
        <div>Lagre bilde</div>
      </NewsTicker>
      <header className="headerwrapper">
        <Gallery description={description} />
      </header>
    </>
  );
}
